import { type ComponentProps } from "react";

import icons from "./generated/icons.generated.json";
import iconsUrl from "./generated/icons.generated.svg";

export type IconName = keyof typeof icons;

type IconProps = ComponentProps<"svg"> & {
  name: IconName;
};

export function Icon({ name, ...rest }: IconProps) {
  const size = icons[name] as [number, number] | undefined;

  if (!size) {
    return null;
  }

  return (
    <svg
      width={size[0]}
      height={size[1]}
      viewBox={`0 0 ${size[0]} ${size[1]}`}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <use href={`${iconsUrl}#icon-${name}`} />
    </svg>
  );
}
